/* eslint-disable @typescript-eslint/no-explicit-any */
import { ENV } from "@/enum/system";

import { BaseSDK, SDKConfig } from "./base";
import { SDKName } from "./types";

interface GoogleTagManagerConfig extends SDKConfig {
  trackingId: string;
}

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export class GoogleTagManagerSDK extends BaseSDK {
  constructor(config: GoogleTagManagerConfig) {
    super(SDKName.GoogleTagManagerSDK, config);
  }

  async initialize(): Promise<void> {
    const config = this.config as GoogleTagManagerConfig;

    // Load Google Analytics script
    const script = document.createElement("script");
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${config.trackingId}');`;
    document.head.appendChild(script);
  }

  getGtmEventName(event: string) {
    let eventName = "";

    switch (event) {
      case "register":
        eventName = "gtm_complete_registration";
        break;
      case "purchase":
        eventName = "gtm_purchase";
        break;
      case "login":
        eventName = "gtm_login";
        break;
      case "first_purchase":
        eventName = "gtm_first_deposit";
        break;
      case "refund":
        eventName = "gtm_withdraw";
        break;
      case "bet_slots":
        eventName = "gtm_bet_slots";
        break;
      case "bet_live_casino":
        eventName = "gtm_bet_live_casino";
        break;
      case "bet_game_show":
        eventName = "gtm_bet_game_show";
        break;
      case "bet_casual_games":
        eventName = "gtm_bet_casual_games";
        break;
      case "bet_sports":
        eventName = "gtm_bet_sports";
        break;
      case "new_purchase_0":
        eventName = "gtm_new_purchase_0";
        break;
      case "new_first_purchase":
        eventName = "gtm_new_purchase";
        break;
      case "high_purchase":
        eventName = "gtm_high_purchase";
        break;
    }
    if (!eventName) {
      eventName = event;
    }

    return eventName;
  }

  reportEvent(event: string, data: Record<string, unknown>): any {
    const eventName = this.getGtmEventName(event);
    //处理事件上报
    let result = false;
    if (window.dataLayer) {
      window.dataLayer.push({ ...data, event: eventName });
      result = true;
    }

    return result;
  }
}
